import { useEffect } from 'react';

import {
  type IResponseAccountWithCodeDTO,
  useAuth,
} from '@gbs-monorepo-packages/auth';
import { Logger } from '@gbs-monorepo-packages/common';

import { redirectDashboard } from '../../services/dashboard';
import { Container, Loading } from './styles';

export const RedirectLogin = (): JSX.Element => {
  const { saveUser } = useAuth();

  useEffect(() => {
    const redirect = async () => {
      try {
        await redirectDashboard().then(
          (response: IResponseAccountWithCodeDTO) => {
            saveUser(response.data);
          }
        );
      } catch (error) {
        Logger.debug('error: ', error);
      }
    };

    void redirect();
  }, []);

  return (
    <Container data-cy="loading-container">
      <Loading />
    </Container>
  );
};
